/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AutogiroApprovalState } from './autogiro-approval-state';
// May contain unused imports in some cases
// @ts-ignore
import type { BackOfficeOverforselsserviceContactDtoV4 } from './back-office-overforselsservice-contact-dto-v4';

/**
 * 
 * @export
 * @interface BackOfficeOverforselsServiceMandateResponseDtoV4AllOf
 */
export interface BackOfficeOverforselsServiceMandateResponseDtoV4AllOf {
    /**
     * 
     * @type {string}
     * @memberof BackOfficeOverforselsServiceMandateResponseDtoV4AllOf
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeOverforselsServiceMandateResponseDtoV4AllOf
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeOverforselsServiceMandateResponseDtoV4AllOf
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {AutogiroApprovalState}
     * @memberof BackOfficeOverforselsServiceMandateResponseDtoV4AllOf
     */
    'state'?: AutogiroApprovalState;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeOverforselsServiceMandateResponseDtoV4AllOf
     */
    'provider'?: BackOfficeOverforselsServiceMandateResponseDtoV4AllOfProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeOverforselsServiceMandateResponseDtoV4AllOf
     */
    'log'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeOverforselsServiceMandateResponseDtoV4AllOf
     */
    'bankAccount'?: string;
    /**
     * 
     * @type {BackOfficeOverforselsserviceContactDtoV4}
     * @memberof BackOfficeOverforselsServiceMandateResponseDtoV4AllOf
     */
    'contactInfo'?: BackOfficeOverforselsserviceContactDtoV4;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeOverforselsServiceMandateResponseDtoV4AllOf
     */
    'type'?: BackOfficeOverforselsServiceMandateResponseDtoV4AllOfTypeEnum;
}

export const BackOfficeOverforselsServiceMandateResponseDtoV4AllOfProviderEnum = {
    MYNT: 'MYNT'
} as const;

export type BackOfficeOverforselsServiceMandateResponseDtoV4AllOfProviderEnum = typeof BackOfficeOverforselsServiceMandateResponseDtoV4AllOfProviderEnum[keyof typeof BackOfficeOverforselsServiceMandateResponseDtoV4AllOfProviderEnum];
export const BackOfficeOverforselsServiceMandateResponseDtoV4AllOfTypeEnum = {
    OVERFORSELSSERVICE: 'OVERFORSELSSERVICE'
} as const;

export type BackOfficeOverforselsServiceMandateResponseDtoV4AllOfTypeEnum = typeof BackOfficeOverforselsServiceMandateResponseDtoV4AllOfTypeEnum[keyof typeof BackOfficeOverforselsServiceMandateResponseDtoV4AllOfTypeEnum];


